package com.anjuros.website.templates.template5.modules

import com.anjuros.website.templates.template5.util.ResKey
import com.anjuros.website.templates.template5.util.Template5CompanyDetails
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_INSTAGRAM_PATH
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_PHONE

enum class Template5ContactItem(
    val icon: String,
    val title: ResKey,
    val value: Template5CompanyDetails,
    val path: String
) {
    Template5ContactItem1(
        icon = "template5_contact1.svg",
        title = ResKey.TEMPLATE5_CONTACT_PHONE_TITLE,
        value = Template5CompanyDetails.CLIENTS_PHONE_INFO,
        path = "tel: $CLIENTS_PHONE"
    ),

    Template5ContactItem2(
        icon = "template5_contact2.svg",
        title = ResKey.TEMPLATE5_CONTACT_EMAIL_TITLE,
        value = Template5CompanyDetails.CLIENTS_EMAIL_INFO,
        path = "mailto:$CLIENTS_EMAIL"
    ),

    Template5ContactItem3(
        icon = "template5_contact3.svg",
        title = ResKey.TEMPLATE5_CONTACT_COLLECTION_TITLE,
        value = Template5CompanyDetails.CLIENTS_SERVICE_AREA_INFO,
        path = ""
    ),

    Template5ContactItem4(
        icon = "template5_contact4.svg",
        title = ResKey.TEMPLATE5_CONTACT_INSTAGRAM_TITLE,
        value = Template5CompanyDetails.CLIENTS_INSTAGRAM_INFO,
        path = "https://www.instagram.com/$CLIENTS_INSTAGRAM_PATH"
    )
}